import apiClient from '../../../core/Api';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

type PropType = {
  currentPassword: string;
  newPassword: string;
};

class UserService {
  static updateUserPassword = async (userId: number, payload: PropType): Promise<string> =>
    apiClient.put(`${API_BASE_URL}/users/${userId}/password`, payload).then((response) => {
      const { data } = response;
      return data.message;
    });
  static updateUserProfilePic = async (userId: number, formData: FormData, config: any): Promise<string> =>
    apiClient.post(`${API_BASE_URL}/users/${userId}/photo`, formData, config).then((response) => {
      const { data } = response;
      return data.message;
    });
  static removeProfilePic = async (userId: number): Promise<string> =>
    apiClient.delete(`${API_BASE_URL}/users/${userId}/photo`).then((response) => {
      const { data } = response;
      return data.message;
    });
}
export default UserService;
